<div class="loader h-100 w-100">
</div>
<div class="content-loader text-center fs-32 cl-white">
  <div class="oval-loader d-flex justify-content-center align-items-center">
    <span class="loader-custom"></span>
    <img class="icon-position" src="assets/logos/2BC_Isotipo_Color_2024.svg" alt="2BCore Logo">
  </div>
</div>